
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Aluminiuamlglasswindow() {



  const cardData =
  {
    keyword: ' Aluminium Glass Window',
    heading: 'Anjali Enterprises: Aluminium Glass Window ',
    headingDescription: 'Anjali Enterprises specializes in the installation of high-quality aluminium glass windows, offering both modern and functional solutions for residential and commercial spaces. Our services are designed to enhance the aesthetic appeal, energy efficiency, and durability of your property while providing the benefits of clear, stylish, and long-lasting glass windows.',

   "topPlaces": [
    {
      "title": "Aluminium Glass Windows",
      "description": "We provide top-quality aluminium glass windows that combine strength, elegance, and functionality. Our windows are designed to offer durability while maintaining a sleek, modern look that complements any space."
    },
    {
      "title": "Installation of Aluminium Windows",
      "description": "Anjali Enterprises offers expert installation services for aluminium windows, ensuring precise fitting and secure installation. Our team ensures that your windows are installed to meet both aesthetic and functional requirements."
    },
    {
      "title": "Modern Glass Windows",
      "description": "Transform your space with modern glass windows made from high-quality aluminium frames. These windows are perfect for those who desire a contemporary and clean aesthetic with excellent durability and energy efficiency."
    },
    {
      "title": "Custom Aluminium Windows",
      "description": "We offer custom aluminium windows tailored to your specific needs and preferences. Whether you require a unique design, size, or finish, we work closely with you to deliver a solution that fits your exact requirements."
    },
    {
      "title": "Sliding Aluminium Glass Windows",
      "description": "Our sliding aluminium glass windows are ideal for spaces where you need easy access or want to maximize natural light. These windows offer smooth functionality and a sleek look, perfect for modern homes and offices."
    },
    {
      "title": "Energy-Efficient Glass Windows",
      "description": "Our energy-efficient glass windows are designed to reduce energy consumption, keeping your interiors comfortable year-round. These windows provide superior insulation, ensuring that your space remains cool in summer and warm in winter."
    },
    {
      "title": "Aluminium Window Installation Services",
      "description": "We provide professional aluminium window installation services to ensure your windows are installed with precision and care. Our team ensures the highest standards of quality and craftsmanship to deliver outstanding results."
    },
    {
      "title": "High-Quality Glass Window Installation",
      "description": "Anjali Enterprises is committed to providing high-quality glass window installation services, using premium materials that enhance the beauty and functionality of your space. We ensure that each window is installed with utmost care and attention to detail."
    },
    {
      "title": "Glass Window Work in Pune",
      "description": "For residents and businesses in Pune, we offer reliable glass window work that combines quality and efficiency. Our services include installation, repairs, and custom solutions to meet your needs."
    },
    {
      "title": "Commercial and Residential Aluminium Windows",
      "description": "We specialize in providing aluminium windows for both commercial and residential properties. Our solutions are designed to offer high performance, visual appeal, and low maintenance for any type of building."
    },
    {
      "title": "Durable Aluminium Window Solutions",
      "description": "Our aluminium window solutions are built to last, offering long-term durability and minimal maintenance. These windows are resistant to corrosion and wear, ensuring that your property stays looking great for years to come."
    },
    {
      "title": "Anjali Enterprises Contact Number:",
      "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality aluminium glass window installation services. We specialize in creating stylish, durable, and energy-efficient aluminium glass windows for both residential and commercial properties. Our windows provide excellent insulation, privacy, and aesthetic appeal. Get in touch for seamless installation and professional service. Serving Pune with top-notch aluminium glass window solutions."
    }
  ],
  "tableData": [
    ["- Aluminium Glass Windows", "- Installation of Aluminium Windows"],
    ["- Modern Glass Windows", "- Custom Aluminium Windows"],
    ["- Sliding Aluminium Glass Windows", "- Energy-Efficient Glass Windows"],
    ["- Aluminium Window Installation Services", "- High-Quality Glass Window Installation"],
    ["- Glass Window Work in Pune", "- Commercial and Residential Aluminium Windows"],
    ["- Durable Aluminium Window Solutions", ""]
  ],


   "whychoose": [
  {
    "WhyChooseheading": "Premium Aluminium Glass Windows",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in offering high-quality aluminium glass windows designed for both residential and commercial properties. Our windows provide the perfect blend of strength, style, and functionality, ensuring long-lasting performance and a sleek, modern aesthetic. With superior craftsmanship, our aluminium glass windows are built to elevate the look of your property while providing practical benefits like durability and energy efficiency."
  },
  {
    "WhyChooseheading": "Custom Designs and Sizes",
    "WhyChoosedescription": "Every property has unique needs, which is why we offer customized aluminium glass windows tailored to fit any size, shape, or design. Whether you’re working on a new construction project or a renovation, we provide windows that seamlessly integrate into your space, ensuring a perfect fit and optimal performance."
  },
  {
    "WhyChooseheading": "Durability and Strength",
    "WhyChoosedescription": "Our aluminium frames are renowned for their durability and resistance to corrosion, making them ideal for windows exposed to harsh weather conditions. Paired with premium-quality glass, our windows provide long-term value by withstanding the elements, ensuring your investment remains functional and attractive for years to come."
  },
  {
    "WhyChooseheading": "Energy Efficiency",
    "WhyChoosedescription": "Our aluminium glass windows are designed with energy efficiency in mind. Offering excellent insulation, these windows help maintain a comfortable indoor temperature, reducing the need for excessive heating or cooling. By improving energy efficiency, they also help lower energy costs while allowing natural light into your home or office without compromising privacy and security."
  },
  {
    "WhyChooseheading": "Stylish and Modern Appeal",
    "WhyChoosedescription": "Aluminium glass windows are the perfect choice for adding a sleek, contemporary touch to your property. We offer a variety of design options, including sliding, casement, and fixed windows, enabling you to achieve the modern, stylish look you desire. These windows enhance both the aesthetic value and functionality of your space."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "At Anjali Enterprises, we offer competitive pricing for all our aluminium glass window solutions. We believe in providing top-quality products without compromising on cost, and our transparent pricing structure ensures no hidden charges. You’ll always know exactly what you're paying for, ensuring peace of mind and great value for your investment."
  },
  {
    "WhyChooseheading": "Efficient Installation",
    "WhyChoosedescription": "Our professional team ensures that your aluminium glass windows are installed quickly and efficiently with minimal disruption. We respect your time and property, making sure the installation process is seamless, and your windows are ready for use in no time. Our focus on efficient and quality installation guarantees a hassle-free experience for you."
  },
  {
    "WhyChooseheading": "Customer Satisfaction",
    "WhyChoosedescription": "Customer satisfaction is at the heart of what we do at Anjali Enterprises. We pride ourselves on delivering high-quality aluminium glass windows that meet the specific needs of each client. With a track record of successful projects and repeat business, we are committed to ensuring your complete satisfaction throughout the process, from consultation to installation."
  }
]


  }

  const faqData = [
    {
      question: "What are the benefits of choosing aluminium glass windows?",
      answer: "Aluminium glass windows offer excellent durability, strength, corrosion resistance, and energy efficiency. They also provide a modern, sleek aesthetic and require minimal maintenance, making them an ideal choice for both residential and commercial properties."
    },
    {
      question: "Can aluminium glass windows be customized to fit my building?",
      answer: "Yes, we provide fully customized aluminium glass windows to suit your building’s size, shape, and design preferences. Whether you need large glass panels or specific frame designs, we can accommodate your requirements."
    },
    {
      question: "Are aluminium glass windows energy-efficient?",
      answer: "Yes, our aluminium glass windows are designed with energy efficiency in mind. They provide excellent insulation, helping to reduce energy consumption and maintain a comfortable indoor temperature year-round."
    },
    {
      question: "How long does it take to install aluminium glass windows?",
      answer: "The installation time depends on the size and complexity of the project. However, our team works efficiently to complete the installation in a timely manner while ensuring the highest quality standards."
    },
    {
      question: "Are aluminium glass windows low maintenance?",
      answer: "Yes, aluminium glass windows are low maintenance. They are easy to clean and do not require frequent upkeep. The aluminium frame is resistant to corrosion, and the glass panels are durable and easy to maintain."
    },
    {
      question: "What types of aluminium glass windows do you offer?",
      answer: "We offer a variety of aluminium glass window types, including sliding windows, casement windows, fixed windows, and more. Each type can be customized to meet your specific needs and preferences."
    },
    {
      question: "Do you provide a warranty on your aluminium glass windows?",
      answer: "Yes, we offer warranties on our aluminium glass windows to ensure that you get a high-quality, durable product that performs well over time."
    },
    {
      question: "How do I get a quote for aluminium glass window installation?",
      answer: "Simply contact us for a free consultation, and we’ll provide a detailed, transparent quote based on your project’s requirements and size."
    },
    {
      question: "Can aluminium glass windows be installed in existing buildings?",
      answer: "Yes, aluminium glass windows can be installed in both new constructions and existing buildings. Our team specializes in retrofitting windows into older structures with minimal disruption."
    },
    {
      question: "Why should I choose Anjali Enterprises for aluminium glass window installation?",
      answer: "Anjali Enterprises offers high-quality aluminium glass windows, expert installation, and a focus on customer satisfaction. Our team is dedicated to delivering the best solutions to meet your needs while ensuring a seamless experience."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Arvind Kumar",
      text: "The aluminium glass windows installed by Anjali Enterprises have completely transformed our office. They’re sleek, modern, and allow natural light to flood in while maintaining privacy. The installation was smooth and quick. Highly recommend!"
    },
    {
      name: "Mrs. Sonal Kapoor",
      text: "We had Anjali Enterprises install aluminium glass windows in our home, and the result is fantastic! The windows are durable, easy to clean, and have improved the overall look of our house. Excellent service!"
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>

<Helmet>
  <title>Contact: +91 8793220265 | Aluminium Glass Window Installation Services in Pune</title>
  <meta name="description" content="Anjali Enterprises provides high-quality aluminium glass window installation services in Pune. We offer modern, custom, and energy-efficient aluminium glass windows for residential and commercial properties. Call +91 8793220265 for your window installation needs." />
  <meta name="keywords" content="Aluminium Glass Windows, Installation of Aluminium Windows, Modern Glass Windows, Custom Aluminium Windows, Sliding Aluminium Glass Windows, Energy-Efficient Glass Windows, Aluminium Window Installation Services, High-Quality Glass Window Installation, Glass Window Work in Pune, Commercial and Residential Aluminium Windows, Durable Aluminium Window Solutions" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Aluminium Glass Window Installation Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises provides high-quality aluminium glass window installation services in Pune. We offer modern, custom, and energy-efficient aluminium glass windows for residential and commercial properties. Call +91 8793220265 for your window installation needs." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/aluminium-glass-window-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/aluminium-glass-window-installation" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises provides high-quality aluminium glass window installation services in Pune. We offer modern, custom, and energy-efficient aluminium glass windows for residential and commercial properties. Call +91 8793220265 for your window installation needs.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/aluminium-glass-window-installation",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/aluminium-glass-window-service.jpg",
        "priceRange": "₹3000 - ₹20000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/aluminium-glass-window-installation",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "45"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ankur S"
            },
            "datePublished": "2024-06-15",
            "reviewBody": "I had aluminium sliding windows installed in my office. The service was great, and the windows are highly durable. Definitely recommend Anjali Enterprises!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya G"
            },
            "datePublished": "2024-10-22",
            "reviewBody": "The aluminium glass windows installed in my home are beautiful and energy-efficient. The installation was quick, and the team was professional."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/aluminium-glass-window-installation"
        },
        "keywords": "Aluminium Glass Windows, Installation of Aluminium Windows, Modern Glass Windows, Custom Aluminium Windows, Sliding Aluminium Glass Windows, Energy-Efficient Glass Windows, Aluminium Window Installation Services, High-Quality Glass Window Installation, Glass Window Work in Pune, Commercial and Residential Aluminium Windows, Durable Aluminium Window Solutions"
      }
    `}
  </script>
</Helmet>




      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/5.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Aluminiuamlglasswindow;